<template>
  <b-card class="mb-4" no-header>
    <!-- <a ref="downloadTemplate" target="_blank" class="d-none" href="https://disdik-api.lksa.or.id/api/v1/spreadsheet/form/school-budget?access_token=xxx"></a> -->
    <ValidationObserver ref="form">
      <!-- <form @submit.prevent="onSubmit">

        </form> -->

      <form @submit.prevent="onSubmit">
        <b-row>
          <b-col md="12">
            <b-button
              variant="success"
              type="button"
              class="mb-2"
              target="_blank"
              :href="baseApiUrl + 'spreadsheet/form/school-budget?access_token=xxx'"
            >
              <font-awesome-icon icon="file-excel" />
              Download Template
            </b-button>
            <p>
              <ul>
                <li>Silahkan download file template, dan hapus baris sekolah yang tidak ingin ditambahkan anggaran jika ada.</li>
                <li>Anggaran yang diisi di file yang diupload hanya akan menambah anggaran sekolah yang belum memiliki anggaran atau mengupdate anggaran sekolah yang belum mengajukan RKAS. Selain itu akan diabaikan.</li>
                <li>Ketika masuk bulan september, anggaran secara automatis masuk ke anggaran semester dua bagi sekolah yang belum memiliki anggaran di semester dua.</li>
                <li>Untuk semester satu silahkan isi anggaran dengan anggaran dasar, sedangkan untuk semester dua masukkan nilai anggaran tambahan.</li>
              </ul>
            </p>
            <formGroupInput
              type="attachmentExcel"
              :needLabel="true"
              label="File Anggaran"
              v-model="fileUpload"
            />
          </b-col>

          <b-col>
            <b-button variant="primary" type="submit" class="float-right">
              Submit
            </b-button>
          </b-col>
        </b-row>
      </form>
    </ValidationObserver>
  </b-card>
</template>

<script>
import { objectToOptions } from "@/_helpers";
// import { objectToOptions, getYears, formatModelValue } from '@/_helpers'
import formGroupInput from "@/components/FormGroupInput.vue";

export default {
  components: {
    formGroupInput,
  },
  data() {
    return {
      isLoading: false,
      totalPromiseAreaCount: 0,
      file: null,
      apiUrl: {},
      baseApiUrl: process.env.VUE_APP_API_URL,
      columns: [],
      list: {
        year: [],
      },
      filter: {},
      dataParams: [],
      fileUpload: null,
    };
  },
  methods: {
    // handleFileUpload( event ){
    //   this.file = event.target.files[0];
    // },
    onSubmit() {
      if (!this.fileUpload) {
        this.$store.dispatch('notification/error', 'Tidak ada file dipilih.')
        return;
      }
      this.$swal.fire({
          title: 'Anda Yakin?',
          text: 'Setelah ini data akan di import!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
          // confirmButtonClass: 'btn btn-danger mr-3',
          // cancelButtonClass: 'btn btn-default',
          // buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.isLoading = true
            let formData = new FormData()
            formData.append('file', this.fileUpload)

            this.$http.post(process.env.VUE_APP_API_URL + "spreadsheet/import/form-budget", formData).then(response => {
              this.isLoading = false
              this.fileUpload = null
              this.$store.dispatch('notification/success', 'File berhasil di import. Sistem akan memproses data anda')
            }).catch(error => {
              this.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
    },
    downloadTemplate() {
      this.$refs.downloadTemplate.click();
    },
  },
};
</script>

<style>
</style>
